<template>
  <div
    v-if="isShow"
    id="cusMask"
    class="custom-mask"
    @contextmenu.prevent
  />
</template>

<script>
export default {
  data() {
    return {
      isShow: false,
      maskClick() {
        console.log('DomClick')
      },
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.maskOnClick()
    })
  },
  methods: {
    maskOnClick() {
      document.getElementById('cusMask').onclick = () => {
        this.maskClick()
      }
    },
  },
}
</script>

<style scoped>
.custom-mask{
  /* background-color:red; */
  position:fixed;
  width:100%;
  height:100%;
  background:rgba(0,0,0,0);
  display:inline-flex;
  justify-content: center;
  align-items: center;
  z-index: 99;
  top: 0;
  left: 0;
}
</style>
